import React, { useState, useRef, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Heading from "../../../../common/element/Heading";
import Segment from "../../../../common/element/Segment";
import Table from "../../../../common/element/Table";
import ClientInput from "../../../../common/element/Input/clientInput";
import Badge from "../../../../common/element/Badge";
import moment from "moment";
import Tag from "../../../../common/element/Tag";
import useCallbackRef from "../../../../common/element/hooks/useCallbackRef";
import Scrollbar from "../../../../common/element/ScrollBar";
import BtnLight from "../../../../common/element/Buttons/btnLight";
import SearchImg from "../../../../assets/icons-svg/search-lg.svg";
import { setBreadcrumbs } from "../../../../redux/classes/breadcrumbsSlice";
import { Link } from "react-router-dom";
import Tooltip from "../../../../common/element/Tooltip";
import Inductions from "./DashboardAllClient/Indunction";
import { debounce } from "../../../../common/snippet/Debouncing";
import TotalClientsAndProviders from "./DashboardAllClient/TotalClientsAndProviders";
import CollapsiblePanel from "../../../../common/element/CollapsiblePanel";
import { DashboardGetAllClientsStatusChart } from "../../../../actions/Admin-Client/AllSiteApi";
import {
  GetAllDeshboardTasks,
  UpdateTaskArchiveStatus,
  MarkTaskAsRead,
  GetNotificationTasksForAdminPortal,
  GetAllConserveTeamAndInvites,
  AssignTaskToUser,
} from "../../../../actions/Admin";
import Select from "../../../../common/element/Select";
import { updateRoutefunc } from "../../../../redux/classes/common/updateRoute";
import { encryptId } from "../../../../common/encryptDecrypt/encryptdecrypt";
import { DashboardAllClientsCompanyInd } from "../../../../actions/Admin-Client/AllSiteApi";
import useUnauthorizedHandler from "../../../../common/snippet/useUnauthorizedHandler";
import { useParams } from "react-router-dom";
import { decryptId } from "../../../../common/encryptDecrypt/encryptdecrypt";
import { GetClientDashboardDueInvoicesByDays } from "../../../../actions/client-portal/invoices/GetClientDashboardDueInvoicesByDays copy";
const Dashboard = () => {
  const loginData = JSON.parse(localStorage.getItem("LoginUserData"));
  const user_id = loginData?.userName?.user_id || loginData?.data?.user_id;
  const userRole = loginData?.data?.role?.role_name;
  const { id } = useParams();
  // const orgId=decryptId(id)
  const dispatch = useDispatch();
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const [clientDataName, setClientDataName] = useState([]);
  const [invoiceData, SetInvoiceData] = useState([]);
  const [totalTastCount, setTotalTaskCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const scrollContainerRef = useRef(null);
  const [scrollThreshold, setScrollThreshold] = useState(23);
  const [limit, setLimit] = useState(30);
  const [searchTerm, setSearchTerm] = useState("");
  const [notificationList, setNotificationList] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [singleSegmentValue, setSingleSegmentValue] = useState(["Inbox"]);
  const [functionId, setfunctionId] = useState("");
  const [clientData, setClientData] = useState(null);
  const [adminTeamMembers, setAdminTeamMembers] = useState([]);
  const AllFunctions = useSelector((state) => state.allFunctions);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const isSuperAdmin = userRole?.toLowerCase() === "super admin";
  const isClientService = userRole?.toLowerCase() === "client service team";

  const getTaskRedirectUrl = (notif) => {
    if (!notif) return "#";

    let providerRoomOrgId = null;
    if (Array.isArray(notif.rooms)) {
      const orgRoom = notif.rooms.find(
        (r) => typeof r === "string" && r.startsWith("org_")
      );
      if (orgRoom) {
        providerRoomOrgId = orgRoom.replace(/^org_/, "").trim();
      }
    }

    const isProviderTask =
      notif.task_assgined?.includes("provider") ||
      notif.rooms?.some(
        (r) => typeof r === "string" && r.trim() === "provider"
      ) ||
      !!providerRoomOrgId;

    const isClientTask =
      notif.task_assgined?.includes("client") ||
      notif.rooms?.some(
        (r) => typeof r === "string" && r.trim() === "client"
      );

    const isWorkerTask =
      notif.is_worker ||
      notif.task_assgined?.includes("worker") ||
      notif.rooms?.some(
        (r) => typeof r === "string" && r.trim() === "worker"
      );

    const rawMsg =
      notif.message ||
      notif.task_message ||
      notif.notification_message ||
      notif.title ||
      notif.task_name ||
      "";
    const msg = rawMsg.toLowerCase();

    let providerTab = "tab1";
    if (
      msg.includes("document") ||
      msg.includes("checklist") ||
      msg.includes("verification") ||
      msg.includes("review") ||
      msg.includes("upload") ||
      msg.includes("client")
    ) {
      providerTab = "tab3";
    } else if (msg.includes("worker")) {
      providerTab = "tab4";
    } else if (msg.includes("payment") || msg.includes("invoice") || msg.includes("fee")) {
      providerTab = "tab5";
    }

    let clientNameParam = "";
    if (providerTab === "tab3" && rawMsg) {
      const forMatch = rawMsg.match(/for\s+([A-Za-z0-9\s\&\-\.\'\"]+)/i);
      if (forMatch && forMatch[1]) {
        const extracted = forMatch[1].trim();
        if (
          extracted &&
          !["verification", "review", "approval", "checklist", "document", "documents"].includes(
            extracted.toLowerCase()
          )
        ) {
          clientNameParam = extracted;
        }
      }
    }

    let clientTab = "tab1";
    if (
      msg.includes("document") ||
      msg.includes("checklist") ||
      msg.includes("verification") ||
      msg.includes("review") ||
      msg.includes("upload")
    ) {
      clientTab = "tab3";
    } else if (msg.includes("provider")) {
      clientTab = "tab2";
    } else if (msg.includes("induction")) {
      clientTab = "tab4";
    } else if (msg.includes("site")) {
      clientTab = "tab5";
    } else if (msg.includes("payment") || msg.includes("invoice") || msg.includes("fee")) {
      clientTab = "tab6";
    }

    if (isProviderTask) {
      const targetOrgId = providerRoomOrgId || notif.organisation_id;
      if (targetOrgId) {
        return `/admin/provider/view-all-provider/specific-provider/${encodeURIComponent(
          encryptId(targetOrgId)
        )}?tab=${providerTab}${clientNameParam ? `&client=${encodeURIComponent(clientNameParam)}` : ""}`;
      }
    }

    if (isClientTask && notif.organisation_id) {
      return `/admin/client/view-all-clients/specific-client/${encodeURIComponent(
        encryptId(notif.organisation_id)
      )}?tab=${clientTab}`;
    }

    if (isWorkerTask) {
      return `/admin/worker/view-all-worker`;
    }

    if (notif.organisation_id) {
      return `/admin/provider/view-all-provider/specific-provider/${encodeURIComponent(
        encryptId(notif.organisation_id)
      )}?tab=${providerTab}${clientNameParam ? `&client=${encodeURIComponent(clientNameParam)}` : ""}`;
    }

    return "#";
  };

  const renderTaskRow = (notif) => (
    <tr
      key={notif.notification_id}
      className="border-b border-gray-100 hover:bg-blue-50/40 transition-colors"
    >
      <td className="pl-6 pr-4 py-3">
        <Link
          className="flex items-center gap-2.5 group"
          to={getTaskRedirectUrl(notif)}
          onClick={() =>
            !notif?.task_read && onMarkAsRead(notif.notification_id)
          }
        >
          {notif?.task_read === true ? (
            <span className="w-2.5 h-2.5 inline-block flex-shrink-0" />
          ) : (
            <span className="w-2.5 h-2.5 rounded-full bg-blue-500 flex-shrink-0" />
          )}
          <Tooltip title={notif.message}>
            <span
              className={`text-sm text-gray-800 w-[450px] noti-newwrap group-hover:text-blue-600 group-hover:underline ${
                notif?.task_read ? "font-normal" : "font-semibold"
              }`}
            >
              {notif.message}
            </span>
          </Tooltip>
        </Link>
      </td>
      <td className="px-4 py-3 text-sm text-gray-500 whitespace-nowrap">
        {moment(notif.created_date).format("HH:mm DD/MM/YY")}
      </td>
      <td className="px-4 py-3">
        <Tooltip title={notif.trading_name}>
          <Link
            to={getTaskRedirectUrl(notif)}
            onClick={() =>
              !notif?.task_read && onMarkAsRead(notif.notification_id)
            }
            className="text-sm font-medium text-gray-700 hover:text-blue-600 hover:underline noti-newwrap w-56 block"
          >
            {notif?.trading_name ? notif.trading_name : "-"}
          </Link>
        </Tooltip>
      </td>
      <td className="px-4 py-3">
        {isSuperAdmin ? (
          <Select
            className="w-52"
            options={adminTeamMembers}
            value={adminTeamMembers.find(
              (m) => m.value === notif.assigned_to_user_id
            )}
            onChange={(val) =>
              handleAssignTask(notif.notification_id, val.value)
            }
            placeholder="Assign"
          />
        ) : (
          <span className="text-sm text-gray-700">
            {notif.assigned_to_name || "-"}
          </span>
        )}
      </td>
      <td className="px-4 py-3">
        {singleSegmentValue[0] === "Inbox" ? (
          <span
            className="text-sm text-blue-600 hover:text-blue-800 font-semibold cursor-pointer transition-colors"
            onClick={() => archiveTask(notif, true)}
          >
            Mark Completed
          </span>
        ) : (
          <span
            className="text-sm text-blue-600 hover:text-blue-800 font-semibold cursor-pointer transition-colors"
            onClick={() => archiveTask(notif, false)}
          >
            Mark Incomplete
          </span>
        )}
      </td>
    </tr>
  );

  const fetchAdminTeamMembers = useCallback(() => {
    if (isSuperAdmin) {
      dispatch(
        GetAllConserveTeamAndInvites(
          undefined, // userType
          undefined, // searchTerm
          1, // filterpage
          undefined, // filterorder
          undefined, // filtersort
          1000, // filterlimit
          "all" // viewType
        )
      ).then((res) => {
        if (res?.success && res.data?.rows) {
          const members = res.data.rows.map((row) => ({
            label: `${row.first_name} ${row.last_name || ""}`.trim(),
            value: row.user_data.user_id,
          }));
          setAdminTeamMembers(members);
        }
      });
    }
  }, [dispatch, isSuperAdmin]);

  useEffect(() => {
    fetchAdminTeamMembers();
  }, [fetchAdminTeamMembers]);

  const handleAssignTask = (notifId, assignedToId) => {
    const payload = {
      notification_id: notifId,
      assigned_to_user_id: assignedToId,
      assigned_by_user_id: user_id,
    };
    dispatch(AssignTaskToUser(payload)).then((res) => {
      if (res?.success) {
        setNotificationList((prevList) =>
          prevList.map((item) => {
            if (item.notification_id === notifId) {
              const assignedMember = adminTeamMembers.find(
                (m) => m.value === assignedToId
              );
              return {
                ...item,
                assigned_to_user_id: assignedToId,
                assigned_to_name: assignedMember?.label,
              };
            }
            return item;
          })
        );
      }
    });
  };

  useEffect(() => {
    if (AllFunctions?.allFunction) {
      let functionType = AllFunctions?.allFunction.filter(
        (item) => item?.function_name === "client"
      );
      setfunctionId(functionType[0]?.function_id);
    }
  }, []);

  const { Tr, Th, Td, THead, TBody } = Table;
  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Dashboard",
          url: "/admin/client/dashboard",
          home: "/admin/client/dashboard",
        },
      ])
    );
  }, []);

  const today = moment().startOf("day");
  const yesterday = moment().subtract(1, "day").startOf("day");
  const startOfWeek = moment().startOf("week");
  const startOfMonth = moment().startOf("month");
  const startOfYear = moment().startOf("year");

  const groupedNotifications = notificationList?.reduce(
    (acc, notification) => {
      const createdDate = moment(notification?.created_date);

      if (createdDate.isSame(today, "d")) {
        acc.today.push(notification);
      } else if (createdDate.isSame(yesterday, "d")) {
        acc.yesterday.push(notification);
      } else if (createdDate.isSameOrAfter(startOfWeek)) {
        acc.thisWeek.push(notification);
      } else if (createdDate.isSameOrAfter(startOfMonth)) {
        acc.thisMonth.push(notification);
      } else if (createdDate.isSameOrAfter(startOfYear)) {
        acc.thisYear.push(notification);
      } else {
        acc.earlier.push(notification);
      }
      return acc;
    },
    {
      today: [],
      yesterday: [],
      thisWeek: [],
      thisMonth: [],
      thisYear: [],
      earlier: [],
    }
  );

  const onSingleSelectionSegmentChange = useCallback(
    (val) => {
      setSingleSegmentValue(val);
    },
    [setSingleSegmentValue]
  );
  const UpdateRoute = () => {
    dispatch(updateRoutefunc(true));
  };
  useEffect(() => {
    const handleScroll = () => {
      const scrollContainer = scrollContainerRef.current;

      if (
        scrollContainer &&
        scrollContainer.scrollTop >= scrollThreshold &&
        !isFetching &&
        notificationList?.length < totalCount
      ) {
        setLimit((prevLimit) => prevLimit + 10);
        setScrollThreshold((prevThreshold) => prevThreshold + 150);
      }
    };
    const scrollContainer = scrollContainerRef.current;
    scrollContainer?.addEventListener("scroll", handleScroll);

    return () => {
      scrollContainer?.removeEventListener("scroll", handleScroll);
    };
  }, [isFetching, scrollThreshold, totalCount, notificationList]);
  const OnGetNotificationTasksForAdminPortal = useCallback(() => {
    // setIsFetching(true);
    const payload = {
      dashboardType: "client",
      limit: limit,
      role_name: userRole,
      user_id: user_id,
      is_archived: singleSegmentValue[0] == "Inbox" ? false : true,
      organisation_id: "",
      search: searchTerm,
    };
    dispatch(GetNotificationTasksForAdminPortal(payload)).then((res) => {
      // setIsFetching(false);
      if (res?.success === true) {
        const arrayData = res.data?.rows || [];
        setNotificationList(arrayData);
        setTotalTaskCount(res.data?.unreadCount || 0);
        setTotalCount(res.data?.count || 0);
      }
    });
  }, [dispatch, singleSegmentValue, searchTerm, limit]);
  useEffect(() => {
    OnGetNotificationTasksForAdminPortal();
  }, [singleSegmentValue, searchTerm, limit]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.trim());
  };
  const inputchangehandler = useCallbackRef(debounce(handleSearch), []);

  const archiveTask = (notify, is_archived = true) => {
    const payload = {
      role_name: userRole,
      notification_id: notify.notification_id,
      is_archived: is_archived,
      user_id: user_id,
      dashboardType: "client",
    };
    dispatch(UpdateTaskArchiveStatus(payload)).then((res) => {
      if (res?.success === true) {
        OnGetNotificationTasksForAdminPortal();
      } else if (res?.status === 401) {
        handleUnauthorizedAccess();
      } else {
        // Handle other errors
      }
    });
  };

  const onMarkAsRead = (notifyId) => {
    const payload = {
      role_name: userRole,
      notification_id: notifyId,
      user_id: user_id,
      task_read: true,
      dashboardType: "client",
    };
    dispatch(MarkTaskAsRead(payload)).then((res) => {
      if (res?.success === true) {
        setTotalTaskCount(totalTastCount - 1); // Fixed typo: 'totalTastCount' -> 'totalTaskCount'
        setNotificationList((prevList) => {
          return prevList.map((item) => {
            if (item?.notification_id === notifyId) {
              return { ...item, task_read: true };
            }
            return item;
          });
        });
      } else if (res?.status === 401) {
        handleUnauthorizedAccess();
      } else {
        // Handle other errors
      }
    });
  };

  const fetchDashboardAllClientsCompanyInd = useCallback(async () => {
    try {
      const response = await dispatch(DashboardAllClientsCompanyInd());
      if (response.success) {
        const arrayData = response?.data;
        setClientDataName(arrayData);
        // setContactFunAssId(arrayData.function_assignment_id);
      } else if (response?.status === 401) {
        handleUnauthorizedAccess();
      } else {
        // Handle other errors
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchDashboardAllClientsCompanyInd();
  }, [fetchDashboardAllClientsCompanyInd]);

  useEffect(() => {
    dispatch(
      GetClientDashboardDueInvoicesByDays({
        client_org_id: "",
      })
    ).then((response) => {
      if (response.success) {
        SetInvoiceData(response.data);
      }
    });
  }, []);

  // Fetch Total Client Details
  const fetchDashboardAllClientsDoughnut = useCallback(() => {
    if (functionId) {
      dispatch(DashboardGetAllClientsStatusChart({ function_id: functionId }))
        .then((response) => {
          if (response.success) {
            setClientData(response?.data);
          } else if (response.status === 401) {
            handleUnauthorizedAccess();
          }
        })
        .catch((error) => {
          // Handle error here
          console.error("Error fetching client data: ", error);
        });
    }
  }, [dispatch, functionId]);

  useEffect(() => {
    fetchDashboardAllClientsDoughnut();
  }, [fetchDashboardAllClientsDoughnut]);

  return (
    <React.Fragment>
      <Heading className="mb-4">Dashboard</Heading>
      <div className="grid grid-container gap-8" style={{ gridTemplateColumns: isCollapsed ? "1fr auto" : undefined }}>
        <div className="flex gap-8 flex-col wrap-dashboard-table">
          <div className="bg-white py-5 rounded-xl dark-shadow">
            <div className="card-header flex justify-between border-b border-gray-200 pb-5 px-5 mb-3">
              <span className="text-gray-900 text-base font-semibold flex items-center">
                <span className="mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6 15L8 17L12.5 12.5M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                Tasks{" "}
                <Tag className="text-blue-800 bg-blue-100 ml-2">
                  {totalTastCount}
                </Tag>
              </span>
            </div>
            <div className="flex justify-between mb-3 px-4">
              <Segment
                className="docType-btn"
                value={singleSegmentValue[0] == "Inbox" ? "Inbox" : "Archive"}
                onChange={(val) => onSingleSelectionSegmentChange(val)}
              >
                <Segment.Item value="Inbox">Open</Segment.Item>
                <Segment.Item value="Archive">Completed</Segment.Item>
              </Segment>
              <div className="w-80 h-10">
                <div className="input-wrapper">
                  <div className="input-suffix-start left-3.5">
                    <img src={SearchImg} alt="" className="h-5" />
                  </div>
                  <ClientInput
                    type="text"
                    className="input  pl-10 w-80  input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    placeholder="Search"
                    inputchangehandler={inputchangehandler}
                    name={"search"}
                  />
                </div>
              </div>
            </div>
            {/* <div className="overflow-hidden"> */}
            <div
              ref={scrollContainerRef}
              className="notification-list-container overflow-y-auto max-h-[839px]"
            >
              <Table className="min-w-full whitespace-nowrap">
                <THead>
                  <Tr>
                    <Th className="pl-6 w-[450px]	">Notification</Th>
                    <Th className="w-40">Timestamp</Th>
                    <Th className="w-56">Company</Th>
                    <Th className="w-32">Assignee</Th>
                    <Th className="w-24">Action</Th>
                  </Tr>
                </THead>
                <tbody className={`overflow-y-auto notification-list `}>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center p-4">
                        Loading...
                      </td>
                    </tr>
                  ) : notificationList.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center p-4">
                        No data available
                      </td>
                    </tr>
                  ) : (
                    <>
                      {groupedNotifications.today.length > 0 && (
                        <>
                          <tr className="bg-gray-50/70 border-y border-gray-100">
                            <td
                              colSpan="5"
                              className="text-blue-700 font-bold px-6 py-2"
                            >
                              Today
                            </td>
                          </tr>
                          {groupedNotifications.today.map(renderTaskRow)}
                        </>
                      )}

                      {groupedNotifications.yesterday.length > 0 && (
                        <>
                          <tr className="bg-gray-50/70 border-y border-gray-100">
                            <td
                              colSpan="5"
                              className="text-blue-700 font-bold px-6 py-2"
                            >
                              Yesterday
                            </td>
                          </tr>
                          {groupedNotifications.yesterday.map(renderTaskRow)}
                        </>
                      )}

                      {groupedNotifications.thisWeek.length > 0 && (
                        <>
                          <tr className="bg-gray-50/70 border-y border-gray-100">
                            <td
                              colSpan="5"
                              className="text-blue-700 font-bold px-6 py-2"
                            >
                              This week
                            </td>
                          </tr>
                          {groupedNotifications.thisWeek.map(renderTaskRow)}
                        </>
                      )}

                      {groupedNotifications.thisMonth.length > 0 && (
                        <>
                          <tr className="bg-gray-50/70 border-y border-gray-100">
                            <td
                              colSpan="5"
                              className="text-blue-700 font-bold px-6 py-2"
                            >
                              This month
                            </td>
                          </tr>
                          {groupedNotifications.thisMonth.map(renderTaskRow)}
                        </>
                      )}

                      {groupedNotifications.thisYear.length > 0 && (
                        <>
                          <tr className="bg-gray-50/70 border-y border-gray-100">
                            <td
                              colSpan="5"
                              className="text-blue-700 font-bold px-6 py-2"
                            >
                              This year
                            </td>
                          </tr>
                          {groupedNotifications.thisYear.map(renderTaskRow)}
                        </>
                      )}

                      {groupedNotifications.earlier.length > 0 && (
                        <>
                          <tr className="bg-gray-50/70 border-y border-gray-100">
                            <td
                              colSpan="5"
                              className="text-blue-700 font-bold px-6 py-2"
                            >
                              Earlier
                            </td>
                          </tr>
                          {groupedNotifications.earlier.map(renderTaskRow)}
                        </>
                      )}
                    </>
                  )}
                </tbody>
                {isFetching && (
                  <div className="flex justify-center py-4">
                    <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-blue-600"></div>
                  </div>
                )}
              </Table>
            </div>
          </div>
          <div className="bg-white py-5 border border-gray-200 rounded-xl dark-shadow">
            <div className="card-header flex justify-between border-b border-gray-200 pb-5 px-5 mb-3">
              <div className="flex items-center">
                <span className="mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M9.35156 14.6667C9.35156 15.9553 10.3962 17 11.6849 17H13.8516C15.2323 17 16.3516 15.8807 16.3516 14.5C16.3516 13.1193 15.2323 12 13.8516 12H11.8516C10.4709 12 9.35156 10.8807 9.35156 9.5C9.35156 8.11929 10.4709 7 11.8516 7H14.0182C15.3069 7 16.3516 8.04467 16.3516 9.33333M12.8516 5.5V7M12.8516 17V18.5M22.8516 12C22.8516 17.5228 18.3744 22 12.8516 22C7.32871 22 2.85156 17.5228 2.85156 12C2.85156 6.47715 7.32871 2 12.8516 2C18.3744 2 22.8516 6.47715 22.8516 12Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <p></p>
                <div className="flex flex-col">
                  <span className="text-gray-900 text-base font-semibold">
                    {" "}
                    Invoices
                  </span>
                  <p className="text-gray-600">Due in the next 30 days </p>
                </div>
              </div>
              {/* <BtnLight className="w-20">View All</BtnLight> */}
              <BtnLight className="w-20 h-9" onClick={() => UpdateRoute()}>
                {" "}
                <Link to={"/admin/client/invoices"}>View All</Link>{" "}
              </BtnLight>
            </div>
            <div className="px-4">
              <div className="max-h-[345px] overflow-y-auto cstm-scrollbar">
                <div>
                  <div className="overflow-hidden border rounded-lg border-gray-200">
                    <Table>
                      <TBody>
                        {invoiceData?.length > 0 &&
                          invoiceData?.length != undefined &&
                          invoiceData?.map((item, index) => {
                            let status;
                            if (item.xero_invoice_status === "AUTHORISED") {
                              const today = new Date();
                              today.setHours(0, 0, 0, 0); // Set time to 00:00:00
                              const invoiceSendDate = new Date(
                                item.invoice_send_date
                              );
                              invoiceSendDate.setHours(0, 0, 0, 0); // Set time to 00:00:00
                              const upcomingCreatedDate = new Date(
                                item.upcoming_created_date
                              );
                              upcomingCreatedDate.setHours(0, 0, 0, 0); // Set time to 00:00:00
                              const dueDate = new Date(item.due_date);
                              dueDate.setHours(0, 0, 0, 0); // Set time to 00:00:00
                              // Check if today's date is between the two dates

                              if (
                                item.upcoming_created_date &&
                                // today >= upcomingCreatedDate &&
                                today < invoiceSendDate
                              ) {
                                status = "UPCOMING";
                              } else if (
                                today >= invoiceSendDate &&
                                today <= dueDate
                              ) {
                                status = "DUE";
                              }
                            }
                            return (
                              <Tr>
                                <Td>{item?.xero_invoice_number}</Td>
                                <Td>
                                  {(status == "UPCOMING" ||
                                    status == "DUE") && (
                                      <Tag className="bg-warning-50 text-warning-700">
                                        <span>
                                          <svg
                                            width="12"
                                            height="12"
                                            viewBox="0 0 12 12"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g clip-path="url(#clip0_18999_70113)">
                                              <path
                                                d="M11.35 5.75L10.3503 6.75L9.34998 5.75M10.4725 6.5C10.4907 6.33583 10.5 6.169 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C7.41363 10.5 8.67502 9.84817 9.5 8.82867M6 3.5V6L7.5 7"
                                                stroke="#F79009"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_18999_70113">
                                                <rect
                                                  width="12"
                                                  height="12"
                                                  fill="white"
                                                />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                        </span>{" "}
                                        {status}
                                      </Tag>
                                    )}
                                </Td>
                                <Td>
                                  {item?.invoice_send_date
                                    ? moment(item?.invoice_send_date).format(
                                      "DD/MM/YYYY"
                                    )
                                    : "-"}
                                </Td>
                              </Tr>
                            );
                          })}
                        {(invoiceData?.length == 0 ||
                          invoiceData?.length == undefined) && (
                            <Td colSpan="2" className="text-center p-4">
                              {/* No data available */}
                              No upcoming invoices
                            </Td>
                          )}
                      </TBody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
        <CollapsiblePanel
          isCollapsed={isCollapsed}
          onToggle={() => setIsCollapsed(!isCollapsed)}
          title="Clients Overview"
        >
          <TotalClientsAndProviders chartData={clientData} title={"Clients"} redirectPath={"/admin/client/view-all-clients"} />
          <Inductions clientDataName={clientDataName} />
        </CollapsiblePanel>
      </div >
    </React.Fragment >
  );
};

export default Dashboard;
